import { SessionProvider } from 'core/infrastructure';

export { default as Search } from '../img/Search.svg';
export { default as SearchBarcode } from '../img/Barcode.svg';
export { default as PrintTicket } from '../img/Print.svg';
export { default as PrepareTicket } from '../img/PrepareTicket.svg';
export { default as RequestCourses } from '../img/RequestCourses.svg';
export { default as ChangeDefaultPreparationOrder } from '../img/ChangeDefaultPreparationOrder.svg';
export { default as PrepareTicketAgain } from '../img/PrepareTicketAgain.svg';
export { default as CloseTicket } from '../img/CloseTicket.svg';
export { default as Settings } from '../img/Settings.svg';
export { default as BackAlt } from '../img/BackAlt.svg';
export { default as Retry } from '../img/Retry.svg';
export { default as SelectUser } from '../img/SelectUser.svg';
export { default as SelectSaleLocation } from '../img/SelectSaleLocation.svg';
export { default as SaleCenter } from '../img/SaleCenter.svg';
export { default as OnlineReservation } from '../img/OnlineReservation.svg';
export { default as Map } from '../img/Map.svg';
export { default as ViewTicket } from '../img/ViewTicket.svg';
export { default as MoveTicket } from '../img/MoveTicket.svg';
export { default as SplitTicket } from '../img/SplitTicket.svg';
export { default as CancelTicket } from '../img/CancelTicket.svg';
export { default as SetTicketDiscounts } from '../img/SetTicketDiscounts.svg';
export { default as Offer } from '../img/Offer.svg';
export { default as SelectTicketInLocation } from '../img/SelectTicketInLocation.svg';
export { default as TicketFriendlyName } from '../img/TicketFriendlyName.svg';
export { default as SetTicketPriceList } from '../img/SetTicketPriceList.svg';
export { default as TableCompanions } from '../img/TableCompanions.svg';
export { default as SellByPLU } from '../img/SellByPLU.svg';
export { default as ComposeUnusualProduct } from '../img/AddUnusualProduct.svg';
export { default as ConfigureSmartMenuOrderComms } from '../img/ConfigureSmartMenuOrderComms.svg';
export { default as ShowTakeOutOrders } from '../img/ShowTakeOutOrders.svg';
export { default as ShowTakeOutOrders_New } from '../img/ShowTakeOutOrders_New.svg';
export { default as ShowRecentSalesByCustomer } from '../img/ShowRecentSalesByCustomer.svg';
export { default as Customer } from '../img/Customer.svg';
export { default as CreateDeliveryNote } from '../img/CreateDeliveryNote.svg';
export { default as CreateSalesOrder } from '../img/CreateSalesOrder.svg';
export { default as CompleteMenu } from '../img/CompleteMenu.svg';
export { default as StartTakeOutOrder } from '../img/StartTakeOutOrder.svg';
export { default as EndTakeOutOrder } from '../img/EndTakeOutOrder.svg';
export { default as ShowDeliveryNotes } from '../img/ShowDeliveryNotes.svg';
export { default as ShowInvoices } from '../img/ShowInvoices.svg';
export { default as ComposeMenu } from '../img/ConfigureMenu.svg';
export { default as ViewTicketAuditory } from '../img/ViewTicketAuditory.svg';
export { default as TipSettings } from '../img/TipSettings.svg';
export { default as ExtractPendingTip } from '../img/ExtractPendingTip.svg';
export { default as GetCoursesToPrepare } from '../img/GetCoursesToPrepare.svg';
export { default as ProductAvailability } from '../img/ProductAvailability.svg';
export { default as CreateLoss } from '../img/Loss.svg';
export { default as ShowAppointments } from '../img/ShowAppointments.svg';
export { default as AddLoyaltyInfo } from '../img/AddLoyaltyInfo.svg';
export { default as RemoveLoyaltyInfo } from '../img/RemoveLoyaltyInfo.svg';
export { default as ServiceCharge } from '../img/ServiceCharge.svg';
export { default as OpenCashDrawer } from '../img/OpenCashDrawer.svg';
export { default as RegisterInputCashTransaction } from '../img/RegisterInputCashTransaction.svg';
export { default as RegisterOutputCashTransaction } from '../img/RegisterOutputCashTransaction.svg';
export { default as CloseDay } from '../img/CloseDay.svg';
export { default as ChangeTicketOpenerUser } from '../img/ChangeTicketOpenerUser.svg';
export { default as InviteTicketLine } from '../img/InviteTicketLine.svg';
export { default as PrintLastClosedTicket } from '../img/PrintLastClosedTicket.svg';
export { default as RefundTicket } from '../img/RefundTicket.svg';
export { default as SelectOpenTicket } from '../img/SelectOpenTicket.svg';
export { default as SearchProductByText } from '../img/SearchProductByText.svg';
export { default as ShowSalesOrdersPreparation } from '../img/ShowSalesOrdersPreparation.svg';
export { default as CancelTicketLine } from '../img/CancelTicketLine.svg';
export { default as DeleteTicketLine } from '../img/DeleteTicketLine.svg';
export { default as SearchTakeOutOrders } from '../img/SearchTakeOutOrders.svg';
export { default as PrintTicketAlways } from '../img/PrintTicketAlways.svg';
export { default as PrintTicketAsk } from '../img/PrintTicketAsk.svg';
export { default as PrintTicketNever } from '../img/PrintTicketNever.svg';
export { default as Log } from '../img/Log.svg';
export { default as Ok } from '../img/OK.svg';
export { default as ComposeProduct } from '../img/ComposeProduct.svg';
export { default as EditMenu } from '../img/EditMenu.svg';
export { default as GetNotes } from '../img/AddTicketLineNote.svg';
export { default as SetTicketLinePreparationOrder } from '../img/SetTicketLinePreparationOrder.svg';
export { default as Left } from '../img/LeftArrow.svg';
export { default as Right } from '../img/RightArrow.svg';
export { default as Cancel } from '../img/Cancel.svg';
export { default as Edit } from '../img/Edit.svg';
export { default as Add } from '../img/Add.svg';
export { default as Delete } from '../img/Delete.svg';
export { default as NewTicket } from '../img/NewTicket.svg';
export { default as Delivery } from '../img/Delivery.svg';
export { default as TakeAway } from '../img/TakeAway.svg';
export { default as RejectOrder } from '../img/RejectOrder.svg';
export { default as CancelOrder } from '../img/CancelOrder.svg';
export { default as PreparedOrder } from '../img/PreparedOrder.svg';
export { default as DeliveringOrder } from '../img/DeliveringOrder.svg';
export { default as DeliveredOrder } from '../img/DeliveredOrder.svg';
export { default as TakeOutNew } from '../img/TakeOutNew.svg';
export { default as TakeOutAccepted } from '../img/TakeOutAccepted.svg';
export { default as TakeOutRejected } from '../img/TakeOutRejected.svg';
export { default as TakeOutPreparing } from '../img/TakeOutPreparing.svg';
export { default as TakeOutPrepared } from '../img/TakeOutPrepared.svg';
export { default as TakeOutDelivering } from '../img/TakeOutDelivering.svg';
export { default as TakeOutDelivered } from '../img/TakeOutDelivered.svg';
export { default as SearchCustomer } from '../img/SearchCustomer.svg';
export { default as RemoveCustomer } from '../img/RemoveCustomer.svg';
export { default as Clear } from '../img/Clear.svg';
export { default as PublishDigitalMenu } from '../img/PublishDigitalMenu.svg';
export { default as ChangeReservation } from '../img/ChangeOnlineReservation.svg';
export { default as RemoveReservation } from '../img/RemoveOnlineReservation.svg';
export { default as Attend } from '../img/Attend.svg';
export { default as PrintPartialBalance } from '../img/PrintPartialBalance.svg';
export { default as PrintTotalBalance } from '../img/PrintTotalBalance.svg';
export { default as Lot } from '../img/Lot.svg';
export { default as NoLot } from '../img/NoLot.svg';
export { default as Next } from '../img/Next.svg';
export { default as CreateInvoice } from '../img/CreateInvoice.svg';
export { default as GetPassword } from '../img/GetPassword.svg';
export { default as OpenDay } from '../img/OpenDay.svg';
export { default as GetSaleFormat } from '../img/SaleFormat.svg';
export { default as Sale } from '../img/Sale.svg';
export { default as ProductDataSheet } from '../img/ProductDataSheet.svg';
export { default as Download } from '../img/Download.svg';
export { default as SetTicketLineCreator } from '../img/SetTicketLineCreator.svg';
export { default as ShowPayments } from '../img/ShowPayments.svg';
export { default as AddPayment } from '../img/AddPayment.svg';
export { default as RemovePayment } from '../img/RemovePayment.svg';
export { default as SendEmail } from '../img/SendEmail.svg';
export { default as WeighProduct } from '../img/WeighProduct.svg';
export { default as Pos } from '../img/Pos.svg';
export { default as SetCustomer } from '../img/SetCustomer.svg';
export { default as TakeOutPaid } from '../img/TakeOutPaid.svg';
export { default as TakeOutInvoiced } from '../img/TakeOutInvoiced.svg';
export { default as EditTicketLine } from '../img/Edit.svg';
export { default as DeliveryOutline } from '../img/Delivery.svg';
export { default as TakeAwayOutline } from '../img/TakeAway.svg';
export { default as ReopenTicket } from '../img/ReopenTicket.svg';
export { default as ChangeInvoicePayment } from '../img/ChangeInvoicePayment.svg';
export { default as UpdateCustomer } from '../img/UpdateCustomer.svg';
export { default as Location } from '../img/Location.svg';
export { default as ShowSalesOrders } from '../img/ShowSalesOrders.svg';
export { default as BalanceIncident } from '../img/BalanceIncident.svg';
export { default as EditDenominations } from '../img/EditDenominations.svg';
export { default as Address } from '../img/Address.svg';
export { default as ChangeDeliveryPerson } from '../img/ChangeDeliveryPerson.svg';
export { default as DeliveryPersonBalance } from '../img/DeliveryPersonBalance.svg';
export { default as Keyboard } from '../img/Keyboard.svg';
export { default as Exit } from '../img/Exit.svg';
export { default as Minimize } from '../img/Minimize.svg';
export { default as CashControlStatus } from '../img/CashControlStatus.svg';
export { default as CasControlStatusWarning } from '../img/CashControlStatusWarning.svg';
export { default as GiveChangeFromCashControl } from '../img/GiveChangeFromCashControl.svg';
export { default as Clocking } from '../img/Clocking.svg';
export { default as ClockIn } from '../img/ClockIn.svg';
export { default as ClockOut } from '../img/ClockOut.svg';
export { default as PayPendingAmount } from '../img/PayPendingAmount.svg';
export { default as TrainingSession } from '../img/TrainingSession.svg';
export { default as PreparationCounter } from '../img/PreparationCounter.svg';
export { default as ShowSystemStatus } from '../img/ShowSystemStatus.svg';
export { default as PointOfSaleStatus } from '../img/PointOfSaleStatus.svg';
export { default as ForceCloseDayAll } from '../img/ForceCloseDayAll.svg';
export { default as ForceCloseDay } from '../img/ForceCloseDay.svg';
export { default as ConfigurePriceList } from '../img/ConfigurePriceList.svg';
export { default as Reset } from '../img/Reset.svg';
export { default as SplitLinePart } from '../img/SplitLinePart.svg';
export { default as SplitTicketPayments } from '../img/SplitTicketPayments.svg';
export { default as SplitTicketAuto } from '../img/SplitTicketAuto.svg';
export { default as SplitTicketManual } from '../img/SplitTicketManual.svg';
export { default as Resume } from '../img/Resume.svg';
export { default as Suspend } from '../img/Suspend.svg';
export { default as UploadLog } from '../img/UploadLog.svg';
export { default as PrepareTicketLine } from '../img/PrepareTicketLine.svg';
export { default as PrepareTicketLineAgain } from '../img/PrepareTicketLineAgain.svg';
export { default as RequestOrderedTicketLine } from '../img/RequestOrderedTicketLine.svg';
export { default as CloseSession } from '../img/CloseSession.svg';
export { default as SetTicketLineDiscount } from '../img/SetTicketLineDiscount.svg';
export { default as AdjustIngredients } from '../img/AdjustIngredients.svg';
export { default as ScaleTickets } from '../img/ScaleTickets.svg';
export { default as SetMinTicketAmount } from '../img/SetMinTicketAmount.svg';
export { default as SetNextSeatNumber } from '../img/SetNextSeatNumber.svg';
export { default as EditLineSeatNumber } from '../img/EditLineSeatNumber.svg';
export { default as TicketGift } from '../img/TicketGift.svg';
export { default as PartialRefund } from '../img/PartialRefund.svg';
export { default as SizeAndColor } from '../img/SizeAndColor.svg';
export { default as SearchByFamiliesAndCategories } from '../img/SearchByFamiliesAndCategories.svg';
export { default as SearchByText } from '../img/SearchByText.svg';
export { default as ParkTicket } from '../img/ParkTicket.svg';
export { default as Warning } from '../img/Warning.svg';
export { default as PreparationOrder } from '../img/PreparationOrder.svg';
export { default as User } from '../img/User.svg';
export { default as Keypad } from '../img/Keypad.svg';
export { default as UserCard } from '../img/UserCard.svg';
export { default as RefundPayment } from '../img/RefundPayment.svg';
export { default as AgoraLogo } from '../img/AgoraLogo.svg';
export { default as Profile } from '../img/Profile.svg';
export { default as Config } from '../img/Config.svg';
export { default as JustPointMore } from '../img/JustPointMore.svg';
export { default as MoneyEdit } from '../img/MoneyEdit.svg';
export { default as Euro } from '../img/Euro.svg';
export { default as Bills } from '../img/Bills.svg';
export { default as Enter } from '../img/Enter.svg';
export { default as Substract } from '../img/Substract.svg';
export { default as MoreOptions } from '../img/MoreOptions.svg';
export { default as Journal } from '../img/Journal.svg';
export { default as Filter } from '../img/Filter.svg';
export { default as SortBy } from '../img/SortBy.svg';
export { default as RefundMoney } from '../img/RefundMoney.svg';
export { default as Clock } from '../img/Clock.svg';
export { default as ServePlate } from '../img/ServePlate.svg';
export { default as FingerPrint } from '../img/FingerPrint.svg';
export { default as HelpInactive } from '../img/HelpInactive.svg';
export { default as HelpActive } from '../img/HelpActive.svg';
export { default as HideKeypad } from '../img/HideKeypad.svg';
export { default as ShowKeypad } from '../img/ShowKeypad.svg';
export { default as Discount } from '../img/Discount.svg';
export { default as ChevronRight } from '../img/ChevronRight.svg';
export { default as ChevronLeft } from '../img/ChevronLeft.svg';
export { default as ChevronUp } from '../img/ChevronUp.svg';
export { default as ChevronDown } from '../img/ChevronDown.svg';
export { default as Shop } from '../img/Shop.svg';
export { default as SeatNumber } from '../img/SeatNumber.svg';
export { default as LineStatusSent } from '../img/LineStatusSent.svg';
export { default as LineStatusCommand } from '../img/LineStatusCommand.svg';
export { default as LineStatusMarch } from '../img/LineStatusMarch.svg';
export { default as TrashCan } from '../img/TrashCan.svg';
export { default as EditQuantity } from '../img/EditQuantity.svg';
export { default as PlateType } from '../img/PlateType.svg';
export { default as Notes } from '../img/Notes.svg';
export { default as SortByAsc } from '../img/SortByAsc.svg';
export { default as SortByDesc } from '../img/SortByDesc.svg';
export { default as BackSpace } from '../img/BackSpace.svg';
export { default as ClearCalculator } from '../img/ClearCalculator.svg';
export { default as ChangeUser } from '../img/ChangeUser.svg';
export { default as Star } from '../img/Star.svg';
export { default as Minus } from '../img/Minus.svg';
export { default as InternalConsumptions } from '../img/InternalConsumptions.svg';
export { default as ShowCardProcessorAdvancedOptions } from '../img/ShowCardProcessorAdvancedOptions.svg';
export { default as Plus } from '../img/Plus.svg';
export { default as IconAvance } from '../img/IconAvance.svg';
export { default as DeliveryMotorcycle } from '../img/DeliveryMotorcycle.svg';
export { default as Delivered } from '../img/Delivered.svg';
export { default as Phone } from '../img/Phone.svg';
export { default as Cif } from '../img/Cif.svg';
export { default as ShowImage } from '../img/ShowImage.svg';
export { default as HideImage } from '../img/HideImage.svg';
export { default as Tag } from '../img/Tag.svg';
export { default as Warehouse } from '../img/Warehouse.svg';
export { default as DeleteUser } from '../img/DeleteUser.svg';
export { default as RecentSales } from '../img/RecentSales.svg';
export { default as ChangeCustomer } from '../img/ChangeCustomer.svg';
export { default as EditUser } from '../img/EditUser.svg';
export { default as Observations } from '../img/Observations.svg';
export { default as Columns } from '../img/Columns.svg';
export { default as Calendar } from '../img/Calendar.svg';
export { default as PrintInvoice } from '../img/PrintInvoice.svg';
export { default as AddUser } from '../img/AddUser.svg';
export { default as InvoiceChangePayment } from '../img/InvoiceChangePayment.svg';
export { default as InvoiceCreate } from '../img/InvoiceCreate.svg';
export { default as InvoicePartialRefund } from '../img/InvoicePartialRefund.svg';
export { default as InvoiceRefund } from '../img/InvoiceRefund.svg';
export { default as InvoiceReopen } from '../img/InvoiceReopen.svg';
export { default as CalendarClock } from '../img/CalendarClock.svg';
export { default as RecentSalesOrders } from '../img/RecentSalesOrders.svg';
export { default as Refresh } from '../img/Refresh.svg';
export { default as Send } from '../img/Send.svg';
export { default as InvoiceCancel } from '../img/InvoiceCancel.svg';
export { default as CancelDeliveryNote } from '../img/CancelDeliveryNote.svg';
export { default as RecentDeliveryNotes } from '../img/RecentDeliveryNotes.svg';
export { default as Tickets } from '../img/Tickets.svg';
export { default as DiscountLabel } from '../img/DiscountLabel.svg';

export { default as DB_REMOVE_DISCOUNT } from '../img/Eliminar.png';
export { default as AGORA_LOGO_SQUARE } from '../img/AgoraLogoSquare.png';
export { default as RUN_ADMIN } from '../img/RunAdmin.png';

export const NULL_IMAGE = '00000000-0000-0000-0000-000000000000';

function isImageId(guid: string): boolean {
	const guidRegex = /^[{(]?[0-9a-fA-F]{8}-([0-9a-fA-F]{4}-){3}[0-9a-fA-F]{12}$/;
	return guidRegex.test(guid);
}

function isValidUrl(url: string) {
	try {
		new URL(url);
		return true;
	}
	catch {
		return false;
	}
}

export function imgSrcFromId(id: string, size?: 'thumb'): string | undefined {

	if (!id || id === NULL_IMAGE)
		return undefined;

	// En ocasiones laguna vez creamos Styles con una imagen local y webpack lo resuelve a una url local de
	// imagen. Ejemplo el botón de quitar descuentos
	if (isValidUrl(id))
		return id;

	const sizeParam = size ? `&size=${size}` : '';
	return isImageId(id) ? `/db-image/?id=${id}${sizeParam}` : undefined;
}

export function imgSrcFromDataSheetId(id: string, size?: 'thumb'): string | undefined {
	if (!id || id === NULL_IMAGE)
		return undefined;

	if (isValidUrl(id))
		return id;

	const maybeHubUrl = SessionProvider.getCurrent().HubUrl;
	const sizeParam = size ? `&size=${size}` : '';
	return isImageId(id) ? `${maybeHubUrl}/db-image/?id=${id}${sizeParam}` : undefined;
}



